(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  const wrap = document.createElement('div');
  wrap.className = 'snow_wrap';
  document.body.appendChild(wrap);

  const MAX_FLAKES = 170;
  const SPAWN_MS = 100;

  function spawnFlake() {
    if (wrap.childElementCount >= MAX_FLAKES) return;

    const flake = document.createElement('i');
    const size = (Math.random() * 8 + 4).toFixed(1);
    const x = (Math.random() * 100).toFixed(2);
    const duration = (Math.random() * 5.4 + 5.4).toFixed(1);
    const delay = (Math.random() * 1.2).toFixed(1); // 0–1.2s
    const drift = ((Math.random() * 2 - 1) * 80).toFixed(0);
    const opacity = (Math.random() * 0.6 + 0.25).toFixed(2);

    flake.style.cssText = `
      --s:${size}px; --x:${x}vw; --d:${duration}s; --dl:${delay}s;
      --dx:${drift}px; --o:${opacity};
    `;

    flake.addEventListener('animationend', () => flake.remove());
    wrap.appendChild(flake);
  }

  setInterval(spawnFlake, SPAWN_MS);
})();
